/**
 * Main JS file for Paragon Underscores theme
 *
 * Will be compiled into js/main.js
 */

import { mobileNavigation } from './modules/mobileNavigation';
import { searchModal } from './modules/searchModal';
import { scrollObserver } from './modules/scrollObserver';
import { handleAlertBanner } from './modules/alertBanner';
import { headerObserver } from './modules/headerObserver';

// run all functions on page load.
document.addEventListener('DOMContentLoaded', function () {
	handleAlertBanner();
	mobileNavigation();
	searchModal();
	scrollObserver();
	headerObserver();
});
